import { useEffect, useState } from "react";

export const KarmaPoolAuthPingManager = (local, setLocal, getURLBasePath) => {

    useEffect(() => {
        if (window.localStorage.getItem("jwtAuthToken") != null) {
            redirectIfNotLoggedIn();
        }
    }, []);

    function authPing(failureCallback) {
        fetch(getURLBasePath() + 'authPing', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {

            })
            .catch((err) => {
                failureCallback();
            });
    }

    function authPingSuccess(successCallback) {
        fetch(getURLBasePath() + 'authPing', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                successCallback();
            })
            .catch((err) => {
            });
    }

    function redirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null && window.location.pathname !== "/karma" &&
            window.location.pathName !== "/karma/friends" && window.location.pathName !== "/karma/exp" && window.location.pathName !== "/karma/about") {
            window.location.href = "/karma";
        }

        authPing(() => {
            window.localStorage.setItem("jwtAuthToken", null);
            setTimeout(function () {
                if (window.location.pathname !== "/karma" && !window.location.pathname.startsWith("/karma/donations") && 
                    !window.location.pathname.startsWith("/karma/friends") && !window.location.pathname.startsWith("/karma/exp" && window.location.pathName !== "/karma/about")) {
                    //window.location.href = "/karma";
                }
            }, 100);
        });
    }

    return {
        authPing, authPingSuccess, redirectIfNotLoggedIn
    };
}